import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TermsConditionsService } from '../../services/terms-conditions.service';
import { ITermsConditionsVersion } from '../../interfaces/terms-conditions-version';
import { observable, computed } from 'mobx-angular';
import { MenuService } from 'src/app/services';

@Component({
  selector: 'terms-conditions',
  templateUrl: 'terms-conditions.component.html',
})
export class TermsAndConditionsComponent implements OnInit {
  public backTo: string;
  public isAgreed: boolean = false;

  @observable termsConditionsVersions: ITermsConditionsVersion[] = [];

  @observable selectedVersionId: number = null;

  @computed get selectedVersion(): ITermsConditionsVersion {
    return this.termsConditionsVersions.find((x) => x.id == this.selectedVersionId);
  }

  public now: Date = new Date();

  private _requiredByDate: Date | null = null;

  public get requiredByDate() {
    return this._requiredByDate;
  }

  public set requiredByDate(value: Date | string | null) {
    if (typeof value === 'string') {
      this._requiredByDate = new Date(value);
    } else {
      this._requiredByDate = value;
    }
    this.menuService.reloadMenu.next(!this.getIsRequiredToSign(this._requiredByDate));
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuService,
    private tcService: TermsConditionsService,
  ) {}

  ngOnInit() {
    this.backTo = this.route.snapshot.params['backTo'];

    this.tcService.getCurrentlyAgreedTermsConditions().then((result) => {
      if (result && result.version.isActual) {
        this.isAgreed = result.isAgreed;
        this.termsConditionsVersions = [
          {
            documentUrl: result.version.documentUrl,
            id: result.versionId,
            isActual: true,
            text: result.version.text,
            version: result.version.version,
            audienceTypeId: null,
            organisationTypeId: null,
            type: 0,
            htmlUrl: result.version.htmlUrl,
            audienceTypeName: result.version.audienceTypeName,
            requiredByDate: result.version.requiredByDate,
          },
        ];
        this.selectedVersionId = result.versionId;
        this.requiredByDate = result.version.requiredByDate;
        if (result.isAgreed) {
          this.menuService.reloadMenu.next(true);
        }
      } else {
        this.isAgreed = false;

        this.tcService.getCurrentAgreement().then((res) => {
          let count = res.length;
          if (count == 0) {
            return;
          }
          this.termsConditionsVersions = res;
          this.selectedVersionId = res[0].id;
          this.requiredByDate = result ? res[0].requiredByDate : null;
          if (Date.now() < new Date(res[0].requiredByDate).getTime()) {
            this.menuService.reloadMenu.next(result != null);
          }
        });
      }
    });
  }

  private getIsRequiredToSign(requiredByDate: Date | null): boolean {
    if (requiredByDate) {
      const date = new Date(requiredByDate);
      return date.getTime() <= Date.now();
    }

    return true;
  }

  close() {
    this.router.navigate(['/app']);
  }

  agree() {
    this.tcService.agreeTermsConditions(this.selectedVersion.id).then((result) => {
      this.close();
    });
  }

  downloadPdf() {
    this.tcService.downloadPdf(this.selectedVersion.documentUrl);
  }
}
